(function () {
  var overlay = null, closeBtn = null, openerBtns = [];

  // ----- Focus trap helpers -----
var lastOpener = null;
function trapFocus(modal){
  var fEls = modal.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
  fEls = Array.prototype.slice.call(fEls).filter(function(el){ return !el.hasAttribute('disabled') && el.offsetParent !== null; });
  if (!fEls.length) return;
  var first = fEls[0], last = fEls[fEls.length - 1];
  modal.addEventListener('keydown', function(e){
    if (e.key !== 'Tab') return;
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });
  // focus the first field (ZIP) or fallback to first focusable
  (document.getElementById('gbm_zip') || first).focus();
}


function openModal(e){
  if (e) { e.preventDefault(); lastOpener = e.currentTarget; }
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden','false');
  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  trapFocus(overlay);
}

function closeModal(){
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden','true');
  overlay.style.display = 'none';
  document.body.style.overflow = '';
  if (lastOpener && typeof lastOpener.focus === 'function') { lastOpener.focus(); }
}

  function onKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function onBackdrop(e) {
    if (e.target === overlay) closeModal();
  }

function wire() {
  overlay = document.getElementById('gbm-cta-overlay');
  if (!overlay) return;

  // Hoist overlay so it's a direct child of <body>
  if (overlay.parentNode !== document.body) {
    document.body.appendChild(overlay);
  }

  // Guarantee closed state on load
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.display = 'none';
  document.body.style.overflow = '';

  closeBtn  = overlay.querySelector('.gbm-cta-close');
  openerBtns = Array.prototype.slice.call(document.querySelectorAll('[data-gbm-cta-open]'));
  openerBtns.forEach(function(btn){ btn.addEventListener('click', openModal); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', onKeydown);
  overlay.addEventListener('click', onBackdrop);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  // ---------- CONFIG: define your areas & estimator ----------
// Replace these with your real logic or hook to your existing gate.
var GBM_LOCAL_ZIPS = new Set([
  // example local zips (fill with your true set)
  '37601','37604','37615','37664','37660','37663'
]);

// Basic in-area shipping zips example; if empty, we treat all US zips as eligible except known excluded.
var GBM_SHIP_EXCLUDED_ZIPS = new Set([
  // put remote AK/HI or heat-restricted zips here if needed
]);

// If you already have GBM_LOCAL_ZIPS defined, keep using it for local
// If you already have this function, replace it with the version below.
function determineZipOutcome(zip, done) {
  // allow promise-style if 'done' not provided
  if (typeof done !== 'function') {
    return new Promise(function (resolve) {
      determineZipOutcome(zip, resolve); // re-enter with a resolver callback
    });
  }

  if (!/^\d{5}$/.test(zip)) return done({ outcome: 'invalid' });

  // Local first
  if (window.GBM_LOCAL_ZIPS && window.GBM_LOCAL_ZIPS.has(zip)) {
    var estLocal = estimateShipping(zip, true);
    return done({ outcome: 'local_available', estimate: estLocal });
  }

  // Use preloaded coordinates for radius
  window.GBM_Zip.ready(function(){
    if (!window.GBM_Zip.has(zip)) {
      return done({ outcome: 'out_of_area' });
    }
    var dist = window.GBM_Zip.milesFromHome(zip);
    if (dist !== null && dist <= 300) {
      return done({ outcome: 'ship_only', estimate: estimateShipping(zip, false) });
    }
    return done({ outcome: 'out_of_area' });
  });
}

// Flat rate inside 300 miles
function estimateShipping(zip, isLocalZip) {
  return 16.95; // ← your flat rate
}

// ---------- Wizard state ----------
var gbmState = {
  step: 1,
  zip: '',
  outcome: null,       // 'ship_only' | 'local_available' | 'out_of_area'
  estimate: null,
  recipient: null,     // {first,last,addr,city,state,zip,note}
};

function gotoStep(n){
  gbmState.step = n;
  document.querySelectorAll('.gbm-step').forEach(function(s){
    s.hidden = parseInt(s.getAttribute('data-step'),10) !== n;
  });

  if (n === 2) document.dispatchEvent(new CustomEvent('GBM_CTA_STEP_2_SHOWN'));
  if (n === 1) document.dispatchEvent(new CustomEvent('GBM_CTA_MODAL_OPEN'));
}

// ---------- Step 1 handlers ----------
function initStep1(){
  var zipInput = document.getElementById('gbm_zip');
  var checkBtn = document.getElementById('gbm_check_zip');
  var resultEl = document.getElementById('gbm_zip_result');
  var continueBtn = document.getElementById('gbm_continue_from_zip');
  var localBtn = document.getElementById('gbm_use_local');

  // ——— Show the “Estimated Shipping Details” block under the ZIP result
  function showShippingInfoSection() {
    var infoBlock = document.getElementById('gbm_shipping_info');
    if (!infoBlock) return;
    infoBlock.hidden = false;                    // reveal the card
    window.GBM_LAST_ZIP = gbmState.zip || '';    // make ZIP visible to estimators
    // fire listeners (ship-date + cost)
    document.dispatchEvent(new CustomEvent('GBM_CTA_MODAL_OPEN'));
  }

  // Hide it when ZIP isn’t shippable
  function hideShippingInfoSection() {
    var infoBlock = document.getElementById('gbm_shipping_info');
    if (infoBlock) infoBlock.hidden = true;
  }


// Inside initStep1(), after you grab zipInput and checkBtn:
zipInput.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    checkBtn.click();
  }
});

checkBtn.addEventListener('click', function () {
  var z = (zipInput.value || '').trim();

  // basic ZIP validation
  if (!/^\d{5}$/.test(z)) {
    resultEl.textContent = 'Please enter a valid 5-digit ZIP code.';
    resultEl.setAttribute('data-error', '');
    return;
  }

  // clear any prior error state
  resultEl.removeAttribute('data-error');

  // continue with your existing ZIP outcome logic
  determineZipOutcome(z);
});


  function renderOutcome(info){
    continueBtn.disabled = true;
    localBtn.style.display = 'none';
    resultEl.textContent = '';

    hideShippingInfoSection();

    if (info.outcome === 'invalid') {
      resultEl.textContent = 'Please enter a valid 5-digit ZIP code.';
      return;
    }
    if (info.outcome === 'out_of_area') {
      resultEl.textContent = "Sorry — we don't ship to this ZIP yet.";
      return;
    }
    if (info.outcome === 'ship_only') {
      resultEl.textContent = "Great news — we can ship here!";
      continueBtn.disabled = false;
      showShippingInfoSection();
      return;
    }
    if (info.outcome === 'local_available') {
      resultEl.textContent = "They're in our local delivery area! You can save on shipping by ordering for them via our Local Delivery checkout, or you can continue with shipping.";
      continueBtn.disabled = false;
      localBtn.style.display = 'inline-block';
      showShippingInfoSection();
      return;
    }
  }

  checkBtn.addEventListener('click', function(e){
    e.preventDefault();
    var z = (zipInput.value || '').trim();

    determineZipOutcome(z, function(info){
      gbmState.zip = z;
      gbmState.outcome = info.outcome;
      gbmState.estimate = info.estimate || null;
      renderOutcome(info);
    });
  });

  continueBtn.addEventListener('click', function(){
    if (gbmState.outcome === 'ship_only' || gbmState.outcome === 'local_available') {
      // Prefill ZIP into step 2
      var recZip = document.getElementById('gbm_rec_zip');
      if (recZip && /^\d{5}$/.test(gbmState.zip)) recZip.value = gbmState.zip;
      gotoStep(2);
    }
  });
}

// --- Minimal fallback validator used if GBM_validateStep2 isn't present ---
function gbmFallbackValidateStep2(){
  var requiredIds = ['gbm_rec_first','gbm_rec_last','gbm_rec_addr','gbm_rec_city','gbm_rec_state','gbm_rec_zip'];
  var firstBad = null;
  function err(input, msg){
    var wrap = input.closest('.field') || input.parentElement;
    if (wrap) {
      wrap.classList.add('gbm-error');
      var m = wrap.querySelector('.gbm-error-msg'); 
      if (!m) { m = document.createElement('div'); m.className='gbm-error-msg'; wrap.appendChild(m); }
      m.textContent = msg || 'This field is required.';
    }
    if (!firstBad) firstBad = input;
  }
  function ok(input){
    var wrap = input.closest('.field') || input.parentElement;
    if (wrap) { wrap.classList.remove('gbm-error'); var m = wrap.querySelector('.gbm-error-msg'); if (m) m.remove(); }
  }

  var bad = false;
  requiredIds.forEach(function(id){
    var el = document.getElementById(id);
    if (!el) return;
    var v = (el.value || '').trim();
    ok(el);
    if (!v) { bad = true; err(el); return; }
    if (id === 'gbm_rec_state' && !/^[A-Za-z]{2}$/.test(v)) { bad = true; err(el,'Use 2-letter state (e.g., TN).'); }
    if (id === 'gbm_rec_zip' && !/^\d{5}(-\d{4})?$/.test(v)) { bad = true; err(el,'Enter a valid ZIP (e.g., 37664 or 37664-1234).'); }
  });

  // banner (optional)
  var banner = document.getElementById('gbm_step2_banner');
  if (!banner) {
    var form = document.getElementById('gbm_recipient_form');
    if (form && form.parentNode) {
      banner = document.createElement('div');
      banner.id='gbm_step2_banner';
      banner.style.marginBottom='10px'; banner.style.color='#a33429'; banner.style.fontWeight='600';
      banner.textContent='Please complete the highlighted fields.'; 
      form.parentNode.insertBefore(banner, form);
    }
  }
  if (banner) banner.hidden = !bad;

  if (bad && firstBad) { firstBad.focus({preventScroll:true}); firstBad.scrollIntoView({behavior:'smooth', block:'center'}); }
  return !bad;
}

// If the full validator block isn't present, use the fallback:
window.GBM_validateStep2 = window.GBM_validateStep2 || gbmFallbackValidateStep2;

// ---------- Step 2 -> Step 3 (review) ----------
function collectRecipient(){
  var rec = {
    first: val('#gbm_rec_first'),
    last:  val('#gbm_rec_last'),
    addr:  val('#gbm_rec_addr'),
    city:  val('#gbm_rec_city'),
    state: (val('#gbm_rec_state') || '').toUpperCase(),
    zip:   val('#gbm_rec_zip'),
    note:  (document.querySelector('#gbm_rec_note') || {}).value || ''
  };

  // match the same rules as the validator:
  var stateOk = /^[A-Za-z]{2}$/.test(rec.state);
  var zipOk   = /^\d{5}(-\d{4})?$/.test(rec.zip);  // ✅ allow ZIP or ZIP+4

  if (!rec.first || !rec.last || !rec.addr || !rec.city || !stateOk || !zipOk) {
    return null;
  }
  return rec;
}
function val(sel){ var el = document.querySelector(sel); return el ? (el.value || '').trim() : ''; }

function initStep2(){
  // Back buttons
  document.querySelectorAll('[data-gbm-back]').forEach(function(btn){
    btn.addEventListener('click', function(){ gotoStep(gbmState.step - 1); });
  });

  // Review button
  var toReview = document.getElementById('gbm_to_review');
  if (!toReview) return;

  // helper: banner ensure
  function ensureBanner(){
    var banner = document.getElementById('gbm_step2_banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'gbm_step2_banner';
      banner.hidden = true;
      banner.style.marginBottom = '10px';
      banner.style.color = '#a33429';
      banner.style.fontWeight = '600';
      banner.textContent = 'Please complete the highlighted fields.';
      var form = document.getElementById('gbm_recipient_form');
      if (form && form.parentNode) form.parentNode.insertBefore(banner, form);
    }
    return banner;
  }

  // helper: put/clear error
  function putError(input, message){
    var wrap = input && (input.closest('.field') || input.parentElement);
    if (!wrap) return;
    wrap.classList.add('gbm-error');

    var lbl = document.querySelector('label[for="'+ input.id +'"]');
    if (lbl) lbl.classList.add('gbm-error-label');

    var msg = wrap.querySelector('.gbm-error-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'gbm-error-msg';
      wrap.appendChild(msg);
    }
    msg.textContent = message || 'This field is required.';

    input.setAttribute('aria-invalid','true');
    msg.id = input.id + '__err';
    input.setAttribute('aria-describedby', msg.id);
  }
  function clearError(input){
    var wrap = input && (input.closest('.field') || input.parentElement);
    if (wrap) {
      wrap.classList.remove('gbm-error');
      var msg = wrap.querySelector('.gbm-error-msg');
      if (msg) msg.remove();
    }
    var lbl = input && document.querySelector('label[for="'+ input.id +'"]');
    if (lbl) lbl.classList.remove('gbm-error-label');
    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }

  // simple validators
  function zipOK(v){ return /^\d{5}(-\d{4})?$/.test((v||'').trim()); }
  function stateOK(v){ return /^[A-Za-z]{2}$/.test((v||'').trim()); }

  toReview.addEventListener('click', function(e){
    // Intercept this click no matter what else is on the page
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    var ids = ['gbm_rec_first','gbm_rec_last','gbm_rec_addr','gbm_rec_city','gbm_rec_state','gbm_rec_zip'];
    var firstBad = null;
    var hadErrors = false;

    // clear previous
    ids.forEach(function(id){
      var el = document.getElementById(id);
      if (el) clearError(el);
    });

    // required checks
    ids.forEach(function(id){
      var el = document.getElementById(id);
      if (!el) return;
      var v = (el.value || '').trim();

      if (!v) {
        putError(el, 'This field is required.');
        hadErrors = true;
        firstBad = firstBad || el;
        return;
      }
      if (id === 'gbm_rec_state' && !stateOK(v)) {
        putError(el, 'Use 2-letter state (e.g., TN).');
        hadErrors = true;
        firstBad = firstBad || el;
        return;
      }
      if (id === 'gbm_rec_zip' && !zipOK(v)) {
        putError(el, 'Enter a valid ZIP (e.g., 37664 or 37664-1234).');
        hadErrors = true;
        firstBad = firstBad || el;
        return;
      }
    });

    // banner + focus or advance
    var banner = ensureBanner();
    if (hadErrors) {
      if (banner) banner.hidden = false;
      if (firstBad) {
        firstBad.focus({ preventScroll: true });
        firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return; // stay on Step 2
    } else {
      if (banner) banner.hidden = true;
    }

    // valid → collect & advance
    var rec = collectRecipient(); // your existing function (already allows ZIP+4)
    if (!rec) return; // hard guard

    gbmState.recipient = rec;
    renderReview();
    gotoStep(3);
  }, true); // <-- capture = true so we run first
}

function renderReview(){
  var box = document.getElementById('gbm_review');
  var r = gbmState.recipient || {};
  var est = gbmState.estimate != null ? ('$' + gbmState.estimate.toFixed(2)) : '—';
  box.innerHTML = [
    '<dl>',
      '<dt>Destination ZIP</dt><dd>', escapeHTML(gbmState.zip || ''), '</dd>',
      '<dt>Recipient</dt><dd>', escapeHTML(r.first || ''), ' ', escapeHTML(r.last || ''), '</dd>',
      '<dt>Address</dt><dd>', escapeHTML(r.addr || ''), ', ', escapeHTML(r.city || ''), ', ', escapeHTML(r.state || ''), ' ', escapeHTML(r.zip || ''), '</dd>',
      '<dt>Personal Note</dt><dd>', escapeHTML(r.note || '—'), '</dd>',
      '<dt>Estimated Shipping</dt><dd>', est, '</dd>',
    '</dl>'
  ].join('');
}

function escapeHTML(s){ return (s||'').replace(/[&<>"']/g, function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]}); }

// ---------- Step 3: Add to Cart ----------
function initStep3(){
  var confirmBtn = document.getElementById('gbm_confirm_add');
  var statusEl = document.getElementById('gbm_add_status');

  confirmBtn.addEventListener('click', function(){
    // get current selected variant id from the product form on the page
    var idInput = document.querySelector('form[action^="/cart/add"] [name="id"]');
    var variantId = idInput ? idInput.value : null;
    if (!variantId) { alert('Variant not found on this product.'); return; }

    var r = gbmState.recipient || {};

    // Pull the flat cost from the UI if present, else fall back
    var costEl   = document.getElementById('gbm_ship_cost');
    var costText = (costEl && costEl.textContent) ? costEl.textContent.trim() : null;
    var cost     = costText || (gbmState.estimate != null ? ('$' + gbmState.estimate.toFixed(2)) : '$16.95');

    // Build a single address line
    var addressLine = [
      (r.addr || '').trim(),
      [ (r.city || '').trim(), (r.state || '').trim() ].filter(Boolean).join(', '),
      (r.zip || '').trim()
    ].filter(Boolean).join(', ');

    // Four concise, admin-friendly properties
    var props = {
      'Shipping Cost': cost,                                               // e.g., "$16.95"
      'Shipping To':   [r.first || '', r.last || ''].filter(Boolean).join(' '),
      'Address':       addressLine
    };
    if ((r.note || '').trim()) props['Note'] = r.note.trim();             // include Note only if provided

statusEl.textContent = 'Adding to cart…';

// Resolve the surcharge variant id (safe if missing)
var feeId = window.GBM_SHIP_ADDON && window.GBM_SHIP_ADDON.variantId;

// Build the multi-item payload
var itemsPayload = [
  {
    id: variantId,
    quantity: 1,
    properties: props
  }
];

// If a fee variant is configured, add it as a second line
if (feeId) {
  itemsPayload.push({
    id: feeId,
    quantity: 1,
    // keep Admin tidy + traceable to the recipient
    properties: {
      'Reason': 'Bakery Box Shipping',
      'For': (props['Shipping To'] || '').trim(),
      'ZIP': (gbmState.zip || ''),
      'Admin Note': 'If you remove this fee from your cart, we will not ship your bakery box!'
    }
  });
}

fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ items: itemsPayload })
})
.then(function(res){ if (!res.ok) throw new Error('Add to cart failed'); return res.json(); })
.then(function(){
  statusEl.textContent = 'Added! Opening cart…';
  // Open cart drawer if theme supports; fallback to redirect
  if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
    theme.cart.getCart(); // Debut/Dawn drawer
  } else {
    window.location.href = '/cart';
  }
})
.catch(function(err){
  console.error(err);
  statusEl.textContent = 'There was a problem adding this item. Please try again.';
});
});   // << close the click handler

}      // << close function initStep3()


// ---------- Boot the wizard after modal is wired ----------
function initWizard(){
  initStep1();
  initStep2();
  initStep3();
  gotoStep(1);
}

// If your existing code already calls wire() on DOMContentLoaded,
// just call initWizard() at the end of that same sequence:
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWizard);
} else {
  initWizard();
}

// -------- Google Places: lazy loader + binder (Card 2 address autocomplete) --------
(function(){
  let mapsLoaded = false;
  let mapsLoading = null;
  let autoInitDone = false;

  function loadGooglePlaces() {
    if (mapsLoaded) return Promise.resolve();
    if (mapsLoading) return mapsLoading;

    const key = (window.GBM_KEYS && window.GBM_KEYS.places) || '';
    if (!key) {
      console.warn('[GBM] Google Places key missing (window.GBM_KEYS.places). Autocomplete disabled.');
      return Promise.resolve(); // don’t break anything
    }
    mapsLoading = new Promise((resolve, reject) => {
      const cbName = '__gbmPlacesCb_' + Math.random().toString(36).slice(2);
      window[cbName] = function() {
        mapsLoaded = true;
        resolve();
        try { delete window[cbName]; } catch(_) {}
      };
      const s = document.createElement('script');
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&callback=${cbName}`;
      s.async = true; s.defer = true;
      s.onerror = () => reject(new Error('Failed to load Google Maps JS'));
      document.head.appendChild(s);
    });
    return mapsLoading;
  }

  // Pull a component by type, with optional short name
  function getComp(components, type, short=false) {
    const c = components.find(x => x.types && x.types.indexOf(type) >= 0);
    if (!c) return '';
    return short ? (c.short_name || '') : (c.long_name || '');
  }

  function formatStreet(place) {
    const comps = place.address_components || [];
    const num   = getComp(comps, 'street_number');
    const route = getComp(comps, 'route');
    const sub   = getComp(comps, 'subpremise'); // apt/suite if provided
    let line1 = [num, route].filter(Boolean).join(' ');
    if (sub) line1 += ` Apt/Suite ${sub}`;
    return line1;
  }

  // Bind once when the form exists (step 2)
  function bindAddressAutocomplete() {
    if (autoInitDone) return;
    const addr = document.getElementById('gbm_rec_addr');
    const city = document.getElementById('gbm_rec_city');
    const state= document.getElementById('gbm_rec_state');
    const zip  = document.getElementById('gbm_rec_zip'); // make sure your ZIP field has this id

    if (!addr || !city || !state || !zip) return; // form not in DOM yet

    // Prevent Enter from submitting form while the dropdown is active
    addr.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') e.preventDefault();
    });

    const ac = new google.maps.places.Autocomplete(addr, {
      fields: ['address_components', 'geometry'],
      types: ['address'],
      componentRestrictions: { country: 'us' }
    });

    ac.addListener('place_changed', () => {
      const place = ac.getPlace();
      if (!place || !place.address_components) return;

      // Fill address line, city, state, zip
      addr.value  = formatStreet(place);
      city.value  = getComp(place.address_components, 'locality')
                 || getComp(place.address_components, 'sublocality')
                 || getComp(place.address_components, 'postal_town')
                 || '';
      state.value = getComp(place.address_components, 'administrative_area_level_1', true);
      const pc    = getComp(place.address_components, 'postal_code');
      const pcsuf = getComp(place.address_components, 'postal_code_suffix');
      zip.value   = pcsuf ? `${pc}-${pcsuf}` : pc;

      // Put cursor at end of address input so user can add unit if needed
      setTimeout(() => { addr.focus(); addr.setSelectionRange(addr.value.length, addr.value.length); }, 0);
    });

    autoInitDone = true;
  }

  // Public-ish: call when the modal opens or when step 2 is shown
  function ensureAddressAutocomplete() {
    loadGooglePlaces()
      .then(() => bindAddressAutocomplete())
      .catch(err => console.warn('[GBM] Places load error:', err));
  }

  // Hook into your modal lifecycle: try on open, and again when step=2 renders.
  // If you already have modal open events, call ensureAddressAutocomplete() there.
  document.addEventListener('GBM_CTA_MODAL_OPEN', ensureAddressAutocomplete);
  document.addEventListener('GBM_CTA_STEP_2_SHOWN', ensureAddressAutocomplete);

  // Fallback: if neither custom event fires, poll briefly after DOM ready.
  document.addEventListener('DOMContentLoaded', () => {
    let tries = 0;
    const id = setInterval(() => {
      tries++;
      if (autoInitDone) { clearInterval(id); return; }
      const step2 = document.querySelector('.gbm-step[data-step="2"]:not([hidden])');
      if (step2) { clearInterval(id); ensureAddressAutocomplete(); }
      if (tries > 30) clearInterval(id);
    }, 300);
  });

  // OPTIONAL: if your own modal JS can dispatch events, do something like:
  // document.dispatchEvent(new CustomEvent('GBM_CTA_MODAL_OPEN'));
  // document.dispatchEvent(new CustomEvent('GBM_CTA_STEP_2_SHOWN'));
})();

// ---------- GBM Ship Date Logic (Thursdays + 2025 holiday windows) ----------
(function(){
  const TZ = 'America/New_York';
  const WEEKLY = { shipWeekday: 3, cutoffHour: 7, cutoffMinute: 0 }; // Wednesday 7:00 AM ET cutoff

  // --- Timezone utilities
  function nowTZ(){
    const p = new Intl.DateTimeFormat('en-CA',{
      timeZone:TZ,year:'numeric',month:'2-digit',day:'2-digit',
      hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false
    }).formatToParts(new Date());
    const v=Object.fromEntries(p.map(x=>[x.type,x.value]));
    return new Date(`${v.year}-${v.month}-${v.day}T${v.hour}:${v.minute}:${v.second}`);
  }
  function fmtDate(d){return d.toLocaleDateString('en-US',{timeZone:TZ,weekday:'long',month:'short',day:'numeric'});}
  function at(iso){return new Date(iso.length===10?`${iso}T00:00:00`:`${iso}:00`);}

  // --- Weekly rule
  function nextThursday(now){
    const d=new Date(now);
    const diff=(WEEKLY.shipWeekday+7-d.getDay())%7;
    d.setDate(d.getDate()+diff);
    d.setHours(9,0,0,0);
    return d;
  }
  function applyWeekly(now){
    if(now.getDay()===WEEKLY.shipWeekday){
      const cutoff=new Date(now);
      cutoff.setHours(WEEKLY.cutoffHour,WEEKLY.cutoffMinute,0,0);
      if(now<cutoff){const t=new Date(now);t.setHours(9,0,0,0);return t;}
      const n=new Date(now);n.setDate(n.getDate()+7);n.setHours(9,0,0,0);return n;
    }
    return nextThursday(now);
  }

  // --- Holiday windows (your final rules)
  const HOLIDAY_RULES=[
    // THANKSGIVING 2025
    {
      label:'(Adjusted for Thanksgiving)',
      start:'2025-11-19T07:00',  // after normal cutoff 11/20 7 AM
      end:'2025-11-25T00:00',    // through 11/25 12 AM
      ship:'2025-11-25'
    },
    { // After the Tuesday window → next regular 12/4
      label:null,
      start:'2025-11-25T00:00',
      end:'2025-12-04T07:00',
      ship:'2025-12-04'
    },
    // CHRISTMAS 2025 / NEW YEAR 2026
    {
      label:'(Adjusted for Christmas)',
      start:'2025-12-17T07:00',  // after normal cutoff 12/18 7 AM
      end:'2025-12-22T00:00',    // through 12/22 12 AM
      ship:'2025-12-22'
    },
    { // After Monday window → next 1/8/26
      label:null,
      start:'2025-12-22T00:00',
      end:'2026-01-08T07:00',
      ship:'2026-01-08'
    }
  ].map(r=>({...r,_start:at(r.start),_end:at(r.end),_ship:at(r.ship)}));

  function applyHoliday(now){
    for(const r of HOLIDAY_RULES){
      if(now>=r._start && now<r._end) return r;
    }
    return null;
  }

  // --- Compute + render
  function computeShip(){
    const now=nowTZ();
    const holiday=applyHoliday(now);
    if(holiday) return holiday;
    return { _ship: applyWeekly(now), label:null };
  }

  function render(){
    const el=document.getElementById('gbm_ship_date');
    if(!el) return;
    try{
      const res=computeShip();
      const txt=`${fmtDate(res._ship)}${res.label?` ${res.label}`:''}`;
      el.textContent=txt;
      // Optional arrival blurb:
      // el.insertAdjacentText('beforeend',' Most orders arrive Friday via overnight.');
    }catch(e){
      console.warn('[GBM] Ship date calc error',e);
      el.textContent='Your box ships on our next weekly ship day.';
    }
  }

  // Fire when the modal opens or step 2 shows; also on DOM ready as a fallback
  document.addEventListener('GBM_CTA_MODAL_OPEN',render);
  document.addEventListener('GBM_CTA_STEP_2_SHOWN',render);
  document.addEventListener('DOMContentLoaded',()=>setTimeout(render,400));
})();

// ---------- GBM Flat Shipping Cost ----------
(function(){
  const FLAT_COST = '$16.95'; // <— update this as needed

  document.addEventListener('GBM_CTA_MODAL_OPEN', () => {
    const el = document.getElementById('gbm_ship_cost');
    if (el) el.textContent = FLAT_COST;
  });
})();

// ---------- GBM Estimated Arrival Date ----------
(function(){
  const TZ = 'America/New_York';

  // helper to format dates consistently
  function fmtDate(d){
    return d.toLocaleDateString('en-US',{timeZone:TZ,weekday:'long',month:'short',day:'numeric'});
  }

  // Called after ship date is computed
  function updateArrival(){
    const shipEl = document.getElementById('gbm_ship_date');
    const arrivalEl = document.getElementById('gbm_arrival_date');
    if(!shipEl || !arrivalEl) return;

    // Parse the displayed ship date back into a Date
    const shipText = shipEl.textContent.match(/([A-Za-z]+,\s+[A-Za-z]+\s+\d+)/);
    if(!shipText) return;

    const ship = new Date(shipText[0] + ' ' + new Date().getFullYear());
    const arrival = new Date(ship);
    arrival.setDate(ship.getDate() + 1); // overnight → next day

    arrivalEl.textContent = fmtDate(arrival);
  }

  // Run whenever the modal opens or the step changes
  document.addEventListener('GBM_CTA_MODAL_OPEN', updateArrival);
  document.addEventListener('GBM_CTA_STEP_2_SHOWN', updateArrival);
  document.addEventListener('DOMContentLoaded', () => setTimeout(updateArrival, 600));
})();

// ---------- GBM Step 2 Validation (error mode) ----------
(function(){
  // IDs already in your form
  var REQ_IDS = [
    'gbm_rec_first',
    'gbm_rec_last',
    'gbm_rec_addr',
    'gbm_rec_city',
    'gbm_rec_state',
    'gbm_rec_zip'
    // add others here if you make more required
  ];

  function ensureBanner(){
    var banner = document.getElementById('gbm_step2_banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'gbm_step2_banner';
      banner.hidden = true;
      banner.style.marginBottom = '10px';
      banner.style.color = '#a33429';
      banner.style.fontWeight = '600';
      banner.textContent = 'Please complete the highlighted fields.';
      // insert banner right before the form
      var form = document.getElementById('gbm_recipient_form');
      if (form && form.parentNode) form.parentNode.insertBefore(banner, form);
    }
    return banner;
  }

  function fieldLabelFor(input){
    // find <label for="...">
    var id = input && input.id;
    if (!id) return null;
    return document.querySelector('label[for="' + id + '"]');
  }

  function putError(input, message){
    var wrap = input.closest('.field') || input.parentElement;
    if (!wrap) return;

    // mark input wrapper
    wrap.classList.add('gbm-error');

    // mark label
    var lbl = fieldLabelFor(input);
    if (lbl) lbl.classList.add('gbm-error-label');

    // add/help text (one only)
    var msg = wrap.querySelector('.gbm-error-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'gbm-error-msg';
      wrap.appendChild(msg);
    }
    msg.textContent = message || 'This field is required.';

    // set aria
    input.setAttribute('aria-invalid', 'true');
    msg.id = input.id + '__err';
    input.setAttribute('aria-describedby', msg.id);
  }

  function clearError(input){
    var wrap = input.closest('.field') || input.parentElement;
    if (wrap) wrap.classList.remove('gbm-error');
    var lbl = fieldLabelFor(input);
    if (lbl) lbl.classList.remove('gbm-error-label');
    var msg = wrap && wrap.querySelector('.gbm-error-msg');
    if (msg) msg.remove();
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
  }

  function zipLooksOk(v){
    return /^\d{5}(-\d{4})?$/.test((v || '').trim());
  }

  function stateLooksOk(v){
    return /^[A-Za-z]{2}$/.test((v || '').trim()); // 2-letter USPS
  }

  // Validate all required inputs; return true if ok
  function validateStep2(){
    var form = document.getElementById('gbm_recipient_form');
    if (!form) return true;

    var firstErrorInput = null;
    var hadErrors = false;

    // validate set
    REQ_IDS.forEach(function(id){
      var el = document.getElementById(id);
      if (!el) return;

      // clear any previous
      clearError(el);

      var v = (el.value || '').trim();
      var needs = el.hasAttribute('required'); // respect your markup

      if (needs && !v) {
        putError(el, 'This field is required.');
        hadErrors = true;
        firstErrorInput = firstErrorInput || el;
        return;
      }

      // extra rules
      if (id === 'gbm_rec_zip' && v && !zipLooksOk(v)) {
        putError(el, 'Enter a valid ZIP (e.g., 37664 or 37664-1234).');
        hadErrors = true;
        firstErrorInput = firstErrorInput || el;
      }
      if (id === 'gbm_rec_state' && v && !stateLooksOk(v)) {
        putError(el, 'Use 2-letter state (e.g., TN).');
        hadErrors = true;
        firstErrorInput = firstErrorInput || el;
      }
    });

    // banner + focus/scroll
    var banner = ensureBanner();
    if (hadErrors) {
      if (banner) banner.hidden = false;
      if (firstErrorInput) {
        firstErrorInput.focus({ preventScroll: true });
        firstErrorInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    } else {
      if (banner) banner.hidden = true;
      return true;
    }
  }

    // make available to the Review button click handler
  window.GBM_validateStep2 = validateStep2;


  // Live: clear error as user types/selects
  function bindLiveClear(){
    var form = document.getElementById('gbm_recipient_form');
    if (!form) return;
    form.addEventListener('input', function(e){
      var t = e.target;
      if (!t || !t.id) return;
      if (REQ_IDS.indexOf(t.id) >= 0) {
        // If non-empty (and valid for zip/state), clear
        var val = (t.value || '').trim();
        if (val.length > 0) {
          if (t.id === 'gbm_rec_zip' && !zipLooksOk(val)) return;
          if (t.id === 'gbm_rec_state' && !stateLooksOk(val)) return;
          clearError(t);
        }
      }
    });
    form.addEventListener('change', function(e){
      var t = e.target;
      if (t && REQ_IDS.indexOf(t.id) >= 0) clearError(t);
    });
  }

  // Hook into your "Review" button for Step 2.
  // Adjust the selector if your button differs.
  function wireReviewGuard(){
    // Common patterns:
    // 1) button with id
    var reviewBtn = document.getElementById('gbm_review_btn');
    // 2) or a data-action
    if (!reviewBtn) reviewBtn = document.querySelector('[data-action="review"]');
    // 3) or the Step 2 primary button
    if (!reviewBtn) reviewBtn = document.querySelector('.gbm-step[data-step="2"] .gbm-step-actions button, .gbm-step[data-step="2"] .gbm-step-actions .btn');

    if (!reviewBtn) return;

    reviewBtn.addEventListener('click', function(ev){
      // if invalid, block transition
      if (!validateStep2()) {
        ev.preventDefault();
        ev.stopPropagation();
        return false;
      }
      // valid → allow your existing code to advance to Review
      return true;
    }, true); // capture to intercept early
  }

  // Initialize when Step 2 is shown (and on DOM ready as a fallback)
  function init(){
    bindLiveClear();
    wireReviewGuard();
  }
  document.addEventListener('GBM_CTA_STEP_2_SHOWN', init);
  document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 400); });
})();


})();
